// import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./HealthTwoBanner.scss"; // Make sure this is included
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
function HealthTwoBanner() {
  const { documents } = useCollection("banners");

  return (
    <div className="health-two-banner-parent">
      {documents && documents.length > 0 ? (
        <Carousel fade interval={3000}>
          {documents &&
            documents.map((myData, index) => (
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={myData.imageUrl}
                  alt="First slide"
                  style={{
                    height: "450px",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
                <Carousel.Caption>
                  <h3>{myData.heading}</h3>
                  <p>{myData.subHeading}</p>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
        </Carousel>
      ) : (
        <p className="text-center my-5">Loading banners...</p>
      )}
    </div>
  );
}

export default HealthTwoBanner;
